import { useState, useEffect, useCallback } from 'react';
import UpdateNotification from './UpdateNotification';

const VersionChecker = () => {
  const [showUpdateNotification, setShowUpdateNotification] = useState(false);

  // Check for updates
  const checkForUpdates = useCallback(async () => {
    try {
      // Add timestamp to prevent caching
      const response = await fetch(`/version.json?t=${Date.now()}`, {
        cache: 'no-cache',
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      });
      
      if (!response.ok) {
        console.warn('Failed to fetch version info');
        return;
      }

      const versionInfo = await response.json();
      const storedVersion = localStorage.getItem('appVersion');
      
      if (!storedVersion) {
        // First time - store current version
        localStorage.setItem('appVersion', versionInfo.version);
      } else if (storedVersion !== versionInfo.version) {
        // New version detected
        setShowUpdateNotification(true);
      }
    } catch (error) {
      console.warn('Error checking for updates:', error);
    }
  }, []);

  // Initial check and periodic checks
  useEffect(() => {
    // Check immediately on mount
    checkForUpdates();

    // Check every 5 minutes
    const intervalId = setInterval(checkForUpdates, 5 * 60 * 1000);

    // Check when tab becomes visible again
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkForUpdates();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [checkForUpdates]);

  const handleUpdate = () => {
    // Clear all caches and reload
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    
    // Clear localStorage version to force re-check
    localStorage.removeItem('appVersion');
    
    // Force a hard reload
    window.location.reload(true);
  };

  const handleDismiss = () => {
    setShowUpdateNotification(false);
    // Show again after 30 minutes if dismissed
    setTimeout(() => {
      checkForUpdates();
    }, 30 * 60 * 1000);
  };

  if (!showUpdateNotification) {
    return null;
  }

  return (
    <UpdateNotification 
      onUpdate={handleUpdate}
      onDismiss={handleDismiss}
    />
  );
};

export default VersionChecker;
